import { getPayrAccounts, getBanksMethodCountry, postPayrPayout } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';
import { debug } from 'util';

Vue.use(Vuex);

const state = {
  selectedBankAccount: {},
  AccountNumber: null,
  file: {},
  bank: null,
  banks: [],
  accounts: [],
  account_payr_id: -1,
  verificationCode: '',
  cod_transaction: null,
  verificationCodeModel: {},
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setPayoutCompleteCodeStatus(state, row) {
    state.payoutCompleteCodeStatus = {
      ...state.payoutCompleteCodeStatus,
      ...row,
    };
  },
  setBanks(state, cols) {
    state.banks = cols;
  },
  setAccounts(state, cols) {
    state.accounts = cols;
  },
  setCodTransaction(state, val) {
    state.cod_transaction = val;
  },
};

const actions = {
  tryGetPayRAccounts({ commit }) {
    getPayrAccounts().then(r => {
      if (r.data.IsSuccess) {
        commit('setAccounts', r.data.Data);
      }
    });
  },
  tryGetBanksMethodCountry({ commit, rootState }) {
    getBanksMethodCountry(rootState.payoutStore.selectedPayoutMethod.pk_mstpayout_method, '').then(r => {
      if (r.data.IsSuccess) {
        commit('setBanks', r.data.Data);
      }
    });
  },
  tryPostPayRPayout({ commit, dispatch }, formData) {
    commit('setPayoutCompleteCodeStatus', { loading: true });
    postPayrPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status === 'OK') {
          dispatch('payoutStore/tryGetPendingPayouts', null, { root: true });
          commit('setCodTransaction', r.data.Data.payout.cod_transaction);
          commit('setPayoutCompleteCodeStatus', {
            success: true,
            error: false,
          });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + r.data.Data.error_code || r.data.Data.message),
          });
        }
      } else {
        if (r.data.ExceptionMessage[0] === 'ROLLOVER_REACHED') {
          commit('payoutStore/setRollover', { error: true }, { root: true });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: r.data.ExceptionMessage[0],
          });
        }
      }
      commit('setPayoutCompleteCodeStatus', { loading: false });
      dispatch('player/tryGetBalance', null, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
